import dynamic from 'next/dynamic';

import { useBreakpoint } from '@contexts/breakpoints';

import { useHotelAvailableDates } from './hooks';

const MobileAvailableRoomDates = dynamic(
  () => import('./MobileAvailableRoomDates'),
  { ssr: false }
);
const DesktopAvailableRoomDates = dynamic(
  () => import('./DesktopAvailableRoomDates'),
  { ssr: false }
);

interface Props {
  roomId?: number;
}

const AvailableRoomDates = ({ roomId }: Props) => {
  const { xl: isDesktop } = useBreakpoint();

  const {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    setVisibleAvailableDates,
    visibleAvailableDates,
    isFetching,
    handleSearch,
    availableDates: data,
  } = useHotelAvailableDates({ roomId: roomId || 0 });

  // when isDesktop === undefined, that mean's we are on the server, so we will render the desktop for better SEO.
  return isDesktop || isDesktop === undefined ? (
    <DesktopAvailableRoomDates
      data={data}
      visibleAvailableDates={visibleAvailableDates}
      setVisibleAvailableDates={setVisibleAvailableDates}
      isFetching={isFetching}
      startDate={startDate}
      endDate={endDate}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      handleSearch={handleSearch}
    />
  ) : (
    <MobileAvailableRoomDates
      data={data}
      visibleAvailableDates={visibleAvailableDates}
      setVisibleAvailableDates={setVisibleAvailableDates}
      startDate={startDate}
      endDate={endDate}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      handleSearch={handleSearch}
    />
  );
};

export default AvailableRoomDates;
